<template>
  <v-container>
    <v-overlay :value="loading_overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-container>
        <div>Anagrafica {{ $route.params.id }}</div>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
                label="Cod"
                v-model="form.cod.val"
                :rules="[rules.required, rules.max(255)]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                label="Nome"
                v-model="form.nome.val"
                :rules="[rules.max(255)]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                label="Cognome"
                v-model="form.cognome.val"
                :rules="[rules.max(255)]"
            >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
                label="Partita Iva"
                v-model="form.piva.val"
                :rules="[rules.piva]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                label="Codice Fiscale"
                v-model="form.cf.val"
                :rules="[rules.cf]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                label="Telefono"
                v-model="form.telefono.val"
                :rules="[rules.max(255)]"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
                label="Email"
                v-model="form.email.val"
                :rules="[rules.max(255), rules.email]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                label="Pec"
                v-model="form.pec.val"
                :rules="[rules.max(255), rules.email]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                label="Indirizzo"
                v-model="form.indirizzo.val"
                :rules="[rules.max(255)]"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field
                label="Citta"
                v-model="form.citta.val"
                :rules="[rules.max(255)]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                label="Cap"
                v-model="form.cap.val"
                :rules="[rules.max(255)]"
            >
            </v-text-field>
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
                label="Dati fattura elettronica"
                v-model="form.dati_fattura_elettronica.val"
                :rules="[rules.max(255)]"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea label="Nota" v-model="form.nota.val" rows="2">
            </v-textarea>
          </v-col>
        </v-row>
        <SchedaToolbar
            :error_show="error_show"
            :error_text="error_text"
            :edit_not_saved="edit_not_saved"
            :edit_mode="editMode"
            :new_button_visibile="true"
            v-on:newItemClick="newItem()"
            v-on:saveItemClick="saveItem()"
            v-on:goBackClick="goBack()"
            :speedDialVisible="true"
            :speed-dial-title="this.form.cod.val ? this.form.cod.val : 'COD' "
        />
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import schedaMixin from "@/mixins/SchedaMixin.js";
import ValidationRulesMixin from "@/mixins/ValidationRulesMixin.js";
import SchedaToolbar from "@/components/SchedaToolbar.vue";
import mj_axios from "@/mj_axios.js";

export default {
  name: "SchedaAnagrafica",
  mixins: [schedaMixin, ValidationRulesMixin],
  components: {SchedaToolbar},
  data: () => ({
    form: {
      cod: {type: "string", val: "", default_val: ""},
      nome: {type: "string", val: "", default_val: ""},
      cognome: {type: "string", val: "", default_val: ""},
      nota: {type: "text", val: "", default_val: ""},
      piva: {type: "string", val: "", default_val: ""},
      cf: {type: "string", val: "", default_val: ""},
      telefono: {type: "string", val: "", default_val: ""},
      email: {type: "string", val: "", default_val: ""},
      pec: {type: "string", val: "", default_val: ""},
      indirizzo: {type: "string", val: "", default_val: ""},
      citta: {type: "string", val: "", default_val: ""},
      cap: {type: "string", val: "", default_val: ""},
      dati_fattura_elettronica: {type: "string", val: "", default_val: ""},
    },
    apiUrl: "/api/anagrafiche",
  }),

  methods: {

    //ovverride + metodi aggiuntivi
    saveItem: function () {
      //ovverride + metodi aggiuntivi
      const pratica_id = this.$route.query.pratica_id; //la catturo prima che schedaMixin cambi la url sulla barra del browser.
      schedaMixin.methods.saveItem.call(this).then(
          () => {
            //faccio in modo che in caso di zero anagrafiche scelte venga mandato un array vuoto (necessario per il controller)
            if (pratica_id) {

              this.loading_overlay = true;
              const params = {
                pratica_id: pratica_id,
                anagrafica_id: this.$route.params.id
              };
              const axios_promise = mj_axios.post('/api/add_anagrafica_to_pratica', params);
              axios_promise.then(() => {

              }).catch(() => {
                this.$store.commit("update_modal_dialog", {
                  title: "Attenzione!!",
                  text: "Errore di salvataggio associazione pratica <-> anagrafica.",
                  visible: true,
                });
              }).then(() => {
                this.loading_overlay = false;
              });
              return axios_promise;
            }
          }
      );


    },

  },
};
</script>
